import React, { useEffect, useState } from 'react';

import { Typography, PageHeader } from 'antd';
import { useTranslation } from 'react-i18next';
import { generatePath, useHistory } from 'react-router';
import { useMedia } from 'react-use';

import { portfolioApi, PortfolioDetails } from 'core/lib';
import PortfolioBuilder from 'core/lib/utils/builders/PortfolioBuilder';
import { Routes } from 'routes/routes';
import { useLoggedInUser } from 'utils/hooks';

import { PortfolioForm } from '../form';

const { Title } = Typography;

const PortfolioNew = () => {
  const { t } = useTranslation(['loaders', 'actions', 'dealbase', 'global']);
  const currentUser = useLoggedInUser();
  const [portfolio] = useState(new PortfolioBuilder().createdBy(currentUser!).build());
  const isMobile = useMedia('(max-width: 768px)');
  const history = useHistory();
  const [activeTabKey, setActiveTabKey] = useState<string>();

  const [postPortfolio, { isLoading: isSaving, isSuccess: saveSuccess, data }] =
    portfolioApi.usePostPortfolioMutation();

  const onSave = (portfolio: PortfolioDetails) => {
    return postPortfolio(portfolio).unwrap();
  };

  useEffect(() => {
    if (saveSuccess) {
      history.push(generatePath(Routes.PORTFOLIO_DETAILS.path, { id: data }));
    }
  }, [saveSuccess, data, history]);

  const onCancel = () => {
    history.push(Routes.PORTFOLIO_LISTING.path);
  };

  return (
    portfolio && (
      <>
        <PageHeader
          title={
            <div className="flex sm:flex-row flex-col items-center gap-2">
              <Title
                className="ws-normal md:truncate w-full text-center"
                style={{ margin: 0 }}
                level={isMobile ? 4 : 3}
              >
                {t('portfolio:placeholders.createPortfolio')}
              </Title>
            </div>
          }
        />
        <PortfolioForm
          activeTabKey={activeTabKey}
          setActiveTabKey={setActiveTabKey}
          isSaving={isSaving}
          portfolio={portfolio}
          onSave={onSave}
          onCancel={onCancel}
          editMode
          isNew
        />
      </>
    )
  );
};

export default PortfolioNew;
